export const FIXED_TOOLBAR_CLASS = 'sticky-global-toolbar';
export default function setupStickyToolbar(toolbarAndBannersContainer) {
  const bodyEl = document.querySelector('body');
  if (!toolbarAndBannersContainer || !bodyEl) {
    return;
  }
  bodyEl.classList.add(FIXED_TOOLBAR_CLASS);
}